// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class LinkedPayorModel {
    static getAttributeTypeMap() {
        return LinkedPayorModel.attributeTypeMap;
    }
}
LinkedPayorModel.discriminator = undefined;
LinkedPayorModel.additionalProperties = false;
LinkedPayorModel.attributeTypeMap = [
    {
        "name": "coverageOrder",
        "baseName": "coverageOrder",
        "type": "number"
    },
    {
        "name": "insurancePayorId",
        "baseName": "insurancePayorId",
        "type": "number"
    },
    {
        "name": "pbmPayorId",
        "baseName": "pbmPayorId",
        "type": "number"
    },
];
//# sourceMappingURL=linkedPayorModel.js.map